import { memo } from "react";
import { Control, FieldValues, Path } from "react-hook-form";
import LabelContainer from "./label-container";
import Select from "./select";

type SelectWithLabelProps<T extends FieldValues> = {
  control: Control<T>;
  name: Path<T>;
  label: string;
  placeholder?: string;
  disabled?: boolean;
  options: { value: string; name: string }[];
  multiple?: boolean;
  error?: string;
  containerClassName?: string;
  showErrorMessage?: boolean;
  /** Title shown at the top of the options bottom sheet */
  selectTitle: string;
};

function SelectWithLabelInner<T extends FieldValues>({
  control,
  name,
  label,
  placeholder,
  disabled,
  options,
  multiple,
  error,
  containerClassName,
  showErrorMessage = true,
  selectTitle,
}: SelectWithLabelProps<T>) {
  return (
    <LabelContainer
      label={label}
      htmlFor={name}
      error={error}
      showErrorMessage={showErrorMessage}
      className={containerClassName}
    >
      <Select
        control={control}
        name={name}
        placeholder={placeholder}
        disabled={disabled}
        options={options}
        multiple={multiple}
        selectTitle={selectTitle}
      />
    </LabelContainer>
  );
}

const SelectWithLabel = memo(SelectWithLabelInner) as typeof SelectWithLabelInner;

export default SelectWithLabel;
